const LAYOUT_MENU_ITEM_IDS = {
  WhyPreferred: 1,
  Performance: 2,
  Products: 3,
  Resources: 4
};
const LAYOUT_MENU_ITEMS = [{
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.WhyPreferred,
  title: {
    rendered: "Why Preferred"
  },
  url: "#",
  columns: [{
    heading: "Program overview",
    description: "Grow your pipeline, close deals, and unlock more earning potential with Zillow Preferred."
  }, {
    links: [{
      title: "Benefits & rewards",
      url: "/preferred/program-benefits/"
    }, {
      title: "Pricing",
      url: "/preferred/pricing/"
    }]
  }]
}, {
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.Performance,
  title: {
    rendered: "Performance"
  },
  url: "#",
  columns: [{
    heading: "Grow your business",
    description: "Explore the standards, metrics, and support you need to reach your goals and keep your business on track."
  }, {
    links: [{
      title: "Program standards",
      url: "/preferred/program-standards/"
    }, {
      title: "Performance report",
      url: "https://premieragent.zillow.com/reports/flex/",
      target: "_blank"
    }]
  }]
}, {
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.Products,
  title: {
    rendered: "Products"
  },
  url: "#",
  columns: [{
    heading: "Zillow’s Integrated Experience",
    description: "Manage leads, streamline workflows, and gain insights with tools that help you grow and close more deals."
  }, {
    links: [{
      title: "Product overview",
      url: "/preferred/product-overview/"
    }, {
      title: "Product updates",
      url: "/preferred/product-updates/"
    }]
  }]
}, {
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.Resources,
  title: {
    rendered: "Resources"
  },
  url: "#",
  columns: [{
    heading: "Fast track your success",
    description: "Access expert-led courses, step-by-step guides, and FAQs to help sharpen your skills and stay ahead."
  }, {
    links: [{
      title: "Onboarding",
      url: "https://academy.zillowgroup.com/learn/lp/439/zillow-preferred-onboarding-learning-plan?generated_by=190880&hash=22ff444808bc8a71daf44de54cc7b4ea730ca4cd"
    }, {
      title: "FAQs",
      url: "/preferred/faq/"
    }, {
      title: "Zillow Academy",
      url: "https://academy.zillowgroup.com/pages/56/enhanced-markets-resource-center",
      target: "_blank"
    }, {
      title: "Market insights",
      url: "/pro/blog/"
    }]
  }]
}];
const HEADER_CTAS = {
  secondary: {
    label: "Sign in"
  }
};
const FOOTER_COLUMNS = [{
  title: LAYOUT_MENU_ITEMS[0].title.rendered,
  description: "",
  links: LAYOUT_MENU_ITEMS[0].columns[1].links
}, {
  title: LAYOUT_MENU_ITEMS[1].title.rendered,
  description: "",
  links: [...LAYOUT_MENU_ITEMS[1].columns[1].links, {
    title: "Compliance & disengagement",
    url: "/preferred/compliance/"
  }]
}, {
  title: LAYOUT_MENU_ITEMS[2].title.rendered,
  description: "",
  links: LAYOUT_MENU_ITEMS[2].columns[1].links
}, {
  title: LAYOUT_MENU_ITEMS[3].title.rendered,
  description: "",
  links: LAYOUT_MENU_ITEMS[3].columns[1].links
}];
export {
  FOOTER_COLUMNS,
  HEADER_CTAS,
  LAYOUT_MENU_ITEMS,
  LAYOUT_MENU_ITEM_IDS
};
